// The React binding for the engine: the overrides applied now, kept in step
// across every component that shows them (a drawer, the theme provider).

import { useEffect, useState } from 'react'
import type { Overrides, StyleGuide } from './engine'

export const useOverrides = (guide: StyleGuide): Overrides => {
  const [overrides, setOverrides] = useState<Overrides>(guide.current())
  useEffect(() => {
    // Catch a change made between the first render and subscribing.
    setOverrides(guide.current())
    return guide.subscribe(setOverrides)
  }, [guide])
  return overrides
}
